/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateMaterialFunctionRequest,
  GetMaterialFunctionParams,
  ListMaterialFunctionsParams,
  MaterialFunctionDto,
  MaterialFunctionId,
  PaginatedMaterialFunctionDto,
  UpdateMaterialFunctionRequest,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getListMaterialFunctionsUrl = (params: ListMaterialFunctionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/material-functions?${stringifiedParams}`
    : `/api/v1/engineering/material-functions`;
};

/**
 * @summary List material functions
 */
export const listMaterialFunctions = async (
  params: ListMaterialFunctionsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedMaterialFunctionDto> => {
  return customFetch<PaginatedMaterialFunctionDto>(getListMaterialFunctionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCreateMaterialFunctionUrl = () => {
  return `/api/v1/engineering/material-functions`;
};

/**
 * @summary Create material function
 */
export const createMaterialFunction = async (
  createMaterialFunctionRequest: CreateMaterialFunctionRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<MaterialFunctionId> => {
  return customFetch<MaterialFunctionId>(getCreateMaterialFunctionUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createMaterialFunctionRequest),
  });
};

export const getGetMaterialFunctionUrl = (
  id: MaterialFunctionId,
  params?: GetMaterialFunctionParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/material-functions/${id}?${stringifiedParams}`
    : `/api/v1/engineering/material-functions/${id}`;
};

/**
 * @summary Get material function
 */
export const getMaterialFunction = async (
  id: MaterialFunctionId,
  params?: GetMaterialFunctionParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<MaterialFunctionDto> => {
  return customFetch<MaterialFunctionDto>(getGetMaterialFunctionUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getUpdateMaterialFunctionUrl = (id: MaterialFunctionId) => {
  return `/api/v1/engineering/material-functions/${id}`;
};

/**
 * @summary Update material function
 */
export const updateMaterialFunction = async (
  id: MaterialFunctionId,
  updateMaterialFunctionRequest: UpdateMaterialFunctionRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateMaterialFunctionUrl(id), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateMaterialFunctionRequest),
  });
};

export const getDeleteMaterialFunctionUrl = (id: MaterialFunctionId) => {
  return `/api/v1/engineering/material-functions/${id}`;
};

/**
 * @summary Delete material function
 */
export const deleteMaterialFunction = async (
  id: MaterialFunctionId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteMaterialFunctionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRestoreMaterialFunctionUrl = (id: MaterialFunctionId) => {
  return `/api/v1/engineering/material-functions/${id}/restore`;
};

/**
 * @summary Restore material function
 */
export const restoreMaterialFunction = async (
  id: MaterialFunctionId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRestoreMaterialFunctionUrl(id), {
    ...options,
    method: "POST",
  });
};
